<script setup lang="ts">
import { computed, ref } from 'vue';

import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';
import type { AppSvgIconColor } from '../appSvgIcon/AppSvgIcon.model';
import AppRawButton from '../appRawButton/AppRawButton.vue';

interface AppTrashCanButtonProps {
  ariaLabel?: string;
}

const props = defineProps<AppTrashCanButtonProps>();

interface AppTrashCanButtonEmits {
  (eventName: 'click', event: MouseEvent): void;
}

const emit = defineEmits<AppTrashCanButtonEmits>();

const hovering = ref<boolean>(false);

const iconColor = computed<AppSvgIconColor>(() =>
  hovering.value ? 'color-neutral-70' : 'color-neutral-60'
);
</script>

<template>
  <AppRawButton
    class="app-trash-can-button"
    :aria-label="props.ariaLabel"
    @click="emit('click', $event)"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
    @focusin="hovering = true"
    @focusout="hovering = false"
  >
    <AppSvgIcon name="trashCanOutlined" size="18" :color="iconColor" />
  </AppRawButton>
</template>

<style scoped lang="scss">
@use '../../styles/media' as *;

.app-trash-can-button {
  --button-size: 32px;

  width: var(--button-size);
  height: var(--button-size);

  border-radius: var(--border-radius-8);
  background-color: transparent;
  transition: var(--transition-very-short);

  display: flex;
  justify-content: center;
  align-items: center;

  @include on-hover {
    background-color: var(--color-neutral-30);
  }

  &:active {
    transform: matrix(0.95, 0, 0, 0.95, 0, 0);
  }
}
</style>
